import Modal from "@app/components/modal";
import ScheduleDemo from "@app/components/schedule-demo";
import { Z_INDECES } from "@app/constants/default";
import { useThemeContext } from "@app/contexts/theme-context";
import Button from "../../button";
import GradientContainer from "../../gradient/gradient-container";
import PartnersLandingSectionPromptModal from "./prompt-modal";

type Prop = {
  offerLabel: string;
};
const PartnersLandingSectionPrompt = ({ offerLabel }: Prop) => {
  const { isMobile, isTablet, isPartnerPromptOpen, setIsPartnerPromptOpen } = useThemeContext();
 
  const isDesktop = !(isMobile || isTablet);
  return (
    <div
      className="px-8 py-6 sm:p-10 lg:px-20 lg:py-10 relative"
      style={{
        zIndex: Z_INDECES.FLOATING_COMPONENT,
      }}
    >
      <GradientContainer overrideClassName="rounded-2xl px-8 py-10 sm:p-12 xl:p-16">
        <div className="grid grid-cols-12 gap-y-8">
          <div className="col-span-12 md:col-span-8 flex flex-col items-start space-y-4">
            {offerLabel ? (
              <span
                className="text-primary-dark rounded-full bg-secondary-low-em 
                label-sm-bold sm-2:label-lg sm:subheading 
                text-center sm:text-start
                py-2 px-3 sm-2:px-6 w-full sm:w-auto"
              >
                {offerLabel}
              </span>
            ) : null}
            <span className="h5 xs:h4 sm:h3 md:h4 lg:h3 xl:h2 text-light">
              Start Saving with SimpleWaste.
            </span>
          </div>
          <ScheduleDemo skipIntro>
            {(setIsScheduleModalOpen) => (
              <div className="relative col-span-12 md:col-span-4 flex items-start md:items-center md:justify-end">
                <Button
                  buttonType="base"
                  className="hidden md:block"
                  size="3xl"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsPartnerPromptOpen(true)
                  }}
                >
                  Schedule Demo
                </Button>
                <Button
                  buttonType="base"
                  className="hidden sm:block md:hidden"
                  full
                  size="3xl"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsPartnerPromptOpen(true)
                  }}
                >
                  Schedule Demo
                </Button>
                <Button
                  buttonType="base"
                  className="sm:hidden"
                  full
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsPartnerPromptOpen(true)
                  }}
                >
                  Schedule Demo
                </Button>
                {isPartnerPromptOpen && (
                  <div className="hidden lg:block absolute top-32">
                    <PartnersLandingSectionPromptModal
                      onClose={() => setIsPartnerPromptOpen(false)}
                      onProceed={() => {
                        setIsScheduleModalOpen(true);
                        setIsPartnerPromptOpen(false);
                      }}
                    />
                  </div>
                )}
                {!isDesktop && (
                  <Modal
                    isOpen={isPartnerPromptOpen}
                    onRequestClose={() => setIsPartnerPromptOpen(false)}
                    overrideStyles={{
                      content: {
                        minHeight: 0,
                        border: 0,
                        padding: 0,
                        borderRadius: 12,
                      },
                    }}
                  >
                    <PartnersLandingSectionPromptModal
                      onClose={() => setIsPartnerPromptOpen(false)}
                      onProceed={() => {
                        setIsScheduleModalOpen(true);
                        setIsPartnerPromptOpen(false);
                      }}
                    />
                  </Modal>
                )}
              </div>
            )}
          </ScheduleDemo>
        </div>
      </GradientContainer>
    </div>
  );
};

export default PartnersLandingSectionPrompt;
